export default "__VITE_ASSET__BJ2fF3zY__"